module.exports = __webpack_public_path__ + "media/images/mobile-only/mobile-only-2-ad935afe285c077416baa4c00d789203.png";